import * as React from 'react'
import * as box2d from 'box2d.ts'

interface Props {
    stage: number,
    initialSize: number,
    targetSizes: number[]
}

const scale = (num, in_min, in_max, out_min, out_max) => {
    return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}

export default class MoneyCanvas extends React.Component<Props, any> {
    canvasNode: React.ReactNode

    constructor(props: any){
        super(props)
        this.state = {
            width: 100,
            height: 100,
            paused: true
        }
        this.addCoin = this.addCoin.bind(this)
        this.removeCoins = this.removeCoins.bind(this)
        this.loop = this.loop.bind(this)
        this.stopLoop = this.stopLoop.bind(this)
        this.startLoop = this.startLoop.bind(this)
        this.world = new box2d.b2World(new box2d.b2Vec2(0, 15))
        this.coins = []
        this.slopes = []
        this.container = []
        this.reshapeList = []
        this.reshapeSlopesList = []
        this.enableSlopes = true
        this.destroyList = []
        this.scale = 250
        this.initialContainerRadius = (window.innerWidth < 800) ? window.innerWidth / 2.5 : scale(window.innerWidth, 100, 2000, 150, 250)
        this.containerRadius = this.resizeCircle(this.initialContainerRadius, this.props.initialSize)
        this.coinRadius = scale(window.innerWidth, 100, 2000, 14, 22)
    }

    private updateDimensions() {
        console.log('Update dimensions')
        this.setState({
            width: window.innerWidth,
            height: window.innerHeight
        }, () => {
            if (!this._frameId) {
                this.createBox2DScene()
                if(!this.state.paused){
                    this.startLoop()
                }
            }
        });
    }

    private createBox2DScene() {
        const bd = new box2d.b2BodyDef()
        const fd = new box2d.b2FixtureDef()

        // Borders definition
        fd.friction = 1
        fd.density = 1
        fd.restitution = 0.75

        // Clean everyting
        for (var b = this.world.GetBodyList(); b; b = b.m_next) {
            this.world.DestroyBody(b)
        }

        // Make the slopes
        for (let i = 0; i < 2; i++) {
            fd.shape = new box2d.b2PolygonShape()
            fd.shape.SetAsBox(
                2 / this.scale,
                this.containerRadius / this.scale / 3)

            bd.position.Set(
                (this.canvasNode.width / 2 / this.scale) - (this.containerRadius / this.scale * (1 - i * 2)),
                (this.canvasNode.height / 2 / this.scale) - this.containerRadius * 0.006
            )
            bd.angle = -45 * (1-i*2)
            this.slopes.push(this.world.CreateBody(bd))
            this.slopes[this.slopes.length - 1].CreateFixture(fd)
        }

        // Make a ring of polygons forming a container
        fd.friction = 0
        fd.density = 0
        fd.restitution = 0
        for (let i = -1; i<6; i++) {
            let angleDeg = 360 / 8 * i * Math.PI / 180
            fd.shape = new box2d.b2PolygonShape()
            fd.shape.SetAsBox(
                2 / this.scale,
                this.containerRadius / this.scale / 3)
            bd.position.Set(
                Math.cos(angleDeg) * (this.containerRadius / this.scale) + (this.canvasNode.width / 2 / this.scale),
                Math.sin(angleDeg) * (this.containerRadius / this.scale) + (this.canvasNode.height / 2 / this.scale))
            bd.angle = angleDeg
            this.container.push(this.world.CreateBody(bd))
            this.container[this.container.length - 1].CreateFixture(fd)
        }
    }

    private resizeCircle(radius, pct): number {
        return Math.sqrt((Math.pow(radius, 2) * Math.PI * pct) / Math.PI, 2)
    }

    private resizeContainer(pct: number) {
        console.log('New container size: ' + pct)
        let oldContainerRadius = this.containerRadius
        this.containerRadius = this.resizeCircle(this.initialContainerRadius, pct)

        if (oldContainerRadius > this.containerRadius) {
            console.log('Shrink: delete slopes')
            this.enableSlopes = false
            this.reshapeSlopesList = this.slopes
        } else {
            this.enableSlopes = true
            this.reshapeSlopesList = this.slopes
        }

        this.reshapeList = this.container
    }

    private addCoin() {
        const bd = new box2d.b2BodyDef()
        const fd = new box2d.b2FixtureDef()

        fd.friction = 0
        fd.density = 1
        fd.restitution = 0.1

        bd.type = box2d.b2BodyType.b2_dynamicBody
        bd.position.Set(this.canvasNode.width / 2 / this.scale + ((this.containerRadius / this.scale / 100 / 2) - (this.containerRadius / this.scale / 100) * Math.random()), 0)
        fd.shape = new box2d.b2CircleShape(this.coinRadius / this.scale)
    
        this.coins.push(this.world.CreateBody(bd))
        this.coins[this.coins.length - 1].CreateFixture(fd)
    }

    private removeCoins() {
        this.destroyList.push(this.coins[0])
        this.coins.shift()
    }

    public getSnapshotBeforeUpdate(prevProps) {
        if(prevProps.stage !== this.props.stage){
            switch(this.props.stage){
                case 1:
                    console.log('STAGE: Start animation')
                    this.setState({paused: false})
                    this.startLoop()
                    break
                case 2:
                    console.log('STAGE 2: Fill the container')
                    break
                case 3:
                    console.log('STAGE 3: Resize container according to the spendings')
                    this.resizeContainer(this.props.targetSizes[0])
                    break
                case 4:
                    console.log('STAGE 4: Resize container according the the highest revenues savings')
                    this.resizeContainer(this.props.targetSizes[1])
                    break
                case 5:
                    console.log('STAGE 4: Resize container according the the lowest revenues savings')
                    this.resizeContainer(this.props.targetSizes[2])
                    break
            }
        }
        return null
    }

    public componentDidMount() {
        this.updateDimensions()
        window.addEventListener("resize", this.updateDimensions.bind(this))
    }

    public componentWillUnmount() {
        this.stopLoop()
    }

    private startLoop() {
        if( !this._frameId ) {
            console.log('frameId doesnt exist: start looping')
            this._frameId = window.requestAnimationFrame( this.loop )
        }
      }
      
    private loop() {
        const ctx = this.canvasNode.getContext("2d")
        this.world.Step(1 / 70, 10, 10)

        // Erase the canvas
        ctx.clearRect(0, 0, this.canvasNode.width, this.canvasNode.height)

        // Remove outbounds coins
        this.coins.forEach((coin, index, coins) => {
            if(coin.GetPosition().y * this.scale > this.canvasNode.height) {
                this.destroyList.push(coin)
                coins.splice(index, 1);
            }
        })

        // Draw the initial income limits
        ctx.strokeStyle = "#d5d6d7"
        ctx.setLineDash([5, 6])
        ctx.lineWidth = 2
        ctx.beginPath()
        ctx.arc(
            this.canvasNode.width / 2, 
            this.canvasNode.height / 2,
            this.initialContainerRadius, 0, 2 * Math.PI)
        ctx.stroke();

        // Draw the coins
        this.coins.forEach((coin, index, coins) => {
            ctx.fillStyle = "#ad427f"
            ctx.beginPath()
            ctx.arc(
                coin.GetPosition().x * this.scale, 
                coin.GetPosition().y * this.scale,
                this.coinRadius - 4, 0, 2 * Math.PI)
            ctx.fill()
        })

        // Draw the borders
        /* for (var b = this.world.GetBodyList(); b; b = b.m_next) {
            if (b.GetType() == 0) {
                const v = b.GetFixtureList().GetShape().m_vertices
                ctx.fillStyle = '#d1d2d3';
                ctx.save()
                ctx.translate(
                    b.GetPosition().x * this.scale,
                    b.GetPosition().y * this.scale)
                ctx.rotate(b.GetAngle())
                ctx.beginPath()
                ctx.moveTo(v[0].x * this.scale, v[0].y * this.scale)
                ctx.lineTo(v[1].x * this.scale, v[1].y * this.scale)
                ctx.lineTo(v[2].x * this.scale, v[2].y * this.scale)
                ctx.lineTo(v[3].x * this.scale, v[3].y * this.scale)
                ctx.closePath()
                ctx.fill()
                ctx.restore()
            }
        } */

        // Draw the riches and poors
        /* ctx.strokeStyle = "#343638"
        ctx.setLineDash([5, 6])
        ctx.lineWidth = 2
        ctx.beginPath()
        ctx.arc(
            this.canvasNode.width / 2, 
            this.canvasNode.height / 2,
            this.containerRadius, 0, 2 * Math.PI)
        ctx.stroke(); */

        // Coins registered to be deleted
        for (let i in this.destroyList) {
            this.world.DestroyBody(this.destroyList[i])
        }
        this.destroyList = []

        // Container borders registered to be updated
        if (this.reshapeList.length > 0) {
            for (let i in this.reshapeList) {
                // Create a new fixture
                const fd = new box2d.b2FixtureDef()
                fd.friction = 0
                fd.density = 0
                fd.restitution = 0.1
                fd.shape = new box2d.b2PolygonShape()
                fd.shape.SetAsBox(
                    2 / this.scale,
                    this.containerRadius / this.scale / 3)

                // Get the brick and destroy the fixture associated to it
                let brick = this.reshapeList[i]
                brick.DestroyFixture(brick.GetFixtureList())

                // Set the new brick body position and fixture
                let angleDeg = 360 / 8 * (i - 1) * Math.PI / 180
                brick.CreateFixture(fd)
                brick.SetPosition({
                    x: Math.cos(angleDeg) * (this.containerRadius / this.scale) + (this.canvasNode.width / 2 / this.scale),
                    y: Math.sin(angleDeg) * (this.containerRadius / this.scale) + (this.canvasNode.height / 2 / this.scale)
                })
            }
            this.reshapeList = []
        }

        // Slope borders registered to be updated
        if (this.reshapeSlopesList.length > 0) {
            for (let i in this.reshapeSlopesList) {
                // Create a new fixture
                const fd = new box2d.b2FixtureDef()
                fd.friction = 0
                fd.density = 0
                fd.restitution = 0.1
                fd.shape = new box2d.b2PolygonShape()
                fd.shape.SetAsBox(
                    2 / this.scale,
                    this.containerRadius / this.scale / 3)

                // Get the slopes and destroy the fixture associated to it
                let slope = this.reshapeSlopesList[i]
                slope.DestroyFixture(slope.GetFixtureList())

                // Set the new slope body position and fixture
                slope.CreateFixture(fd)
                if (this.enableSlopes) {
                    slope.SetPosition({
                        x: (this.canvasNode.width / 2 / this.scale) - (this.containerRadius / this.scale * (1 - i * 2)),
                        y: (this.canvasNode.height / 2 / this.scale) - this.containerRadius * 0.006
                    })
                } else {
                    slope.SetPosition({
                        x: 9999,
                        y: 9999
                    })
                }
            }
            this.reshapeSlopesList = []
        }

        // Fill the container with coins while the surface of all the coins is less than
        // the surface of the container. Had to multiply the surface of the coins by a 
        // value to take into account the parts not covered by the coins
        if (Math.pow(this.containerRadius, 2) * Math.PI > 
            (Math.pow(this.coinRadius, 2) * Math.PI * this.coins.length * 1.11)) {
            this.addCoin()
        }

        // Draw the top and bottom gradients
        var gradient = ctx.createLinearGradient(0, 0, 0, this.canvasNode.height * 0.1);
        gradient.addColorStop(0, 'rgba(255,255,255,1)');
        gradient.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, this.canvasNode.width, this.canvasNode.height * 0.1);

        this._frameId = window.requestAnimationFrame( this.loop )
    }
    
    private stopLoop() {
        window.cancelAnimationFrame( this._frameId )
        this._frameId = null
    }

    public render() {
        return (
            <canvas
                ref={el => {this.canvasNode = el}}
                width={this.state.width}
                height={this.state.height}
            />
        );
    }
}